import { takeEvery, put, call, all, fork } from "redux-saga/effects";

import {
  ADD_VEHICLE,
  VEHICLE_DETAILS,
  VEHICLES_LIST,
  UPDATE_VEHICLE,
  DELETE_VEHICLE,
  VEHICLE_HISTORY,
  DELETE_ATTACHMENT,
  ADD_VEHICLE_ATTACHMENT,
  GET_VEHICLE_LOGS,
} from "./actionTypes";
import {
  getVehicleDetailSuccess,
  getVehicleDetailFail,
  getvehiclesSuccess,
  getvehiclesFail,
  updateVehicleSuccess,
  updateVehicleFail,
  deleteVehicleSuccess,
  deleteVehicleFail,
  getVehicleHistorySuccess,
  getVehicleHistoryFail,
  deleteAttachmentSuccess,
  deleteAttachmentFail,
  addVehicleAttachmentSuccess,
  addVehicleAttachmentFail,
  addVehicleSuccess,
  addVehicleFail,
  getVehicleLogsSuccess,
  getVehicleLogsFail,
} from "./actions";

import {
  onAddVehicle,
  onGettingVehicleDetails,
  onDeletingVehicle,
  onUpdateVehicle,
  onGetVehiclesList,
  onGettingVehicleHistory,
  onDeleteVehicleFile,
  onAddVehicleFile,
  onGettingVehicleLogs,
} from "helpers/fakebackend_helper";
import showToast from "common/Notification";
import { responseHandler } from "common/CommanFunction";
const toastTitle = "Vehicle";

function* onGetList({ payload: data }) {
  try {
    const response = yield call(onGetVehiclesList, data);
    yield put(getvehiclesSuccess(response));
  } catch (error) {
    yield put(getvehiclesFail(error));
  }
}

function* onDelete({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onDeletingVehicle, data);
    yield call(responseHandler, toastTitle, response, deleteVehicleSuccess, deleteVehicleFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(deleteVehicleFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onGetVehicleLogs({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onGettingVehicleLogs, data);
    yield call(responseHandler, toastTitle, response, getVehicleLogsSuccess, getVehicleLogsFail, onSuccess, onError, false);
  } catch (error) {
    onError();
    yield put(getVehicleLogsFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onAdd({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onAddVehicle, data);
    yield call(responseHandler, toastTitle, response, addVehicleSuccess, addVehicleFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(addVehicleFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onAddFile({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onAddVehicleFile, data);
    yield call(responseHandler, toastTitle, response, addVehicleAttachmentSuccess, addVehicleAttachmentFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(addVehicleAttachmentFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onDeleteFile({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onDeleteVehicleFile, data);
    yield call(responseHandler, toastTitle, response, deleteAttachmentSuccess, deleteAttachmentFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(deleteAttachmentFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onGetDetails({ payload: data }) {
  try {
    const response = yield call(onGettingVehicleDetails, data);
    yield put(getVehicleDetailSuccess(response));
  } catch (error) {
    yield put(getVehicleDetailFail(error));
  }
}

function* onUpdate({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onUpdateVehicle, data);
    yield call(responseHandler, toastTitle, response, updateVehicleSuccess, updateVehicleFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(updateVehicleFail(error));
    showToast("error", toastTitle, error);
  }
}

function* onGetHistory({ payload: data }) {
  try {
    const response = yield call(onGettingVehicleHistory, data);
    yield put(getVehicleHistorySuccess(response));
  } catch (error) {
    yield put(getVehicleHistoryFail(error));
  }
}

export function* serviceListSaga() {
  yield takeEvery(ADD_VEHICLE, onAdd);
  yield takeEvery(UPDATE_VEHICLE, onUpdate);
  yield takeEvery(VEHICLES_LIST, onGetList);
  yield takeEvery(DELETE_VEHICLE, onDelete);
  yield takeEvery(VEHICLE_DETAILS, onGetDetails);
  yield takeEvery(VEHICLE_HISTORY, onGetHistory);
  yield takeEvery(DELETE_ATTACHMENT, onDeleteFile);
  yield takeEvery(ADD_VEHICLE_ATTACHMENT, onAddFile);
  yield takeEvery(GET_VEHICLE_LOGS, onGetVehicleLogs);
}

export default serviceListSaga;
